import React from 'react';
import styled from 'styled-components';
import { Responsive, Grid } from 'semantic-ui-react';

const Container = styled.div`
  background-color: #e4ff5f;
  padding: 10px;
  text-align: center;
`;

const Label = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  margin: 20px auto;
  max-width: 220px;
`;

const Image = ({
  label,
  index,
  shortTxt
}: {
  label: string;
  index: number;
  shortTxt?: boolean;
}) => {
  return (
    <div style={{ maxWidth: 210 }}>
      <img
        width="100%"
        alt="tool"
        src={require(`../assets/images/tool${index}.png`)}
        style={shortTxt ? { marginBottom: 15 } : undefined}
      />
      <Label>{label}</Label>
    </div>
  );
};

const MobileImage = ({ label, index }: { label: string; index: number }) => {
  return (
    <div>
      <img alt="tool" src={require(`../assets/images/tool${index}.png`)} />
      <Label>{label}</Label>
    </div>
  );
};

const DATA = [
  {
    image: 1,
    shortTxt: false,
    lable: 'Apply Pay and Credit Cards payment processing'
  },
  {
    image: 2,
    shortTxt: true,
    lable: 'Venmo payout'
  },
  {
    image: 3,
    shortTxt: true,
    lable: '$1.99 Shipping'
  },
  {
    image: 4,
    shortTxt: true,
    lable: 'Easily sync all your products from Shopify'
  }
];

export default () => {
  return (
    <Container>
      <div className="container-box white-box">
        <div style={{ maxWidth: 700, margin: '0 auto' }}>
          <h2 className="title" style={{ marginTop: 40 }}>
            An Easy and Transparent Partnership
          </h2>
        </div>
        <p className="description">
          You’ve already done all the great work creating products people love.
          Let us do the rest!
        </p>
        <Responsive minWidth={1024}>
          <Grid>
            <Grid.Row columns={4}>
              {DATA.map(({ image, lable, shortTxt }) => {
                return (
                  <Grid.Column key={image}>
                    <Image index={image} label={lable} shortTxt={shortTxt} />
                  </Grid.Column>
                );
              })}
            </Grid.Row>
          </Grid>
        </Responsive>
        <Responsive minWidth={641} maxWidth={1023}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <MobileImage index={DATA[0].image} label={DATA[0].lable} />
              </Grid.Column>
              <Grid.Column>
                <MobileImage index={DATA[1].image} label={DATA[1].lable} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <MobileImage index={DATA[2].image} label={DATA[2].lable} />
              </Grid.Column>
              <Grid.Column>
                <MobileImage index={DATA[3].image} label={DATA[3].lable} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Responsive>
        <Responsive maxWidth={640}>
          {DATA.map(item => {
            return (
              <MobileImage
                key={item.image}
                index={item.image}
                label={item.lable}
              />
            );
          })}
        </Responsive>
      </div>
      <div />
    </Container>
  );
};
